import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import AddFeature from './AddFeature/AddFeature'
import FeatureComponent from './FeatureComponent'
import showToastr from '../../utils/showToastr'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'

import './Layout/Feature.css'

class SingleFeatureScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      data: null,
      isAddFeatureBoxVisible: false,
      isLoading: true,
      showNotFound: false
    }

    this.loadFeature = this.loadFeature.bind(this)
    this.addFeatureHandler = this.addFeatureHandler.bind(this)
  }

  loadFeature (id) {
    this.setState({isLoading: true, showNotFound: false})
    Actions.featureInfo(id).then((res) => {
      this.setState({data: res.data, isLoading: false})
    }).catch((e) => {
      this.setState({isLoading: false})
      if (e.response.status === 404) {
        this.setState({showNotFound: true})
      }
    })
  }

  addFeatureHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', 'امکان جدید', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isAddFeatureBoxVisible: show})
  }

  componentWillMount () {
    if (this.props.feature) {
      return this.setState({data: this.props.feature, isLoading: false, showNotFound: false})
    }
    this.loadFeature(this.props.params.key)
  }

  render () {
    const { data, isAddFeatureBoxVisible, isLoading, showNotFound } = this.state
    const { user, auth } = this.props
    return (
      <div id="feature-screen">
        <AddFeature isVisible={isAddFeatureBoxVisible} toggler={this.addFeatureHandler} />
        <Grid>
          <Row>
            <Col sm={10} smOffset={1} xs={12} xsOffset={0}>
              <Row className="title">
                <h2>ویژگی جدید</h2>
                <Button onClick={() => browserHistory.push('/new-features')} bsStyle="info" className="add-feature">نمایش همه ویژگی های جدید</Button>
              </Row>

              {isLoading ? <HorseLoading />
                : showNotFound ? <NotFound route={this.props.location} />
                : (<Row className="wrapper">
                  <Helmet>
                    <title>Iaho</title>
                    <meta name="description" content={data.title + ' با تعداد ' + data.point + '/' + data.maxPoint} />
                    <meta property="og:title" content={data.title} />
                    <meta property="og:locale" content="fa_IR" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="ایاهو | موتور جستجوی اسب اصیل" />
                    <meta property="og:description" content={data.title + ' با تعداد ' + data.point + '/' + data.maxPoint} />
                    <meta property="og:image" content="https://iaho.ir/MiniLogo.jpg" />
                    <meta property="og:url" content="https://iaho.ir/" />
                    <meta property="twitter:description" content={data.title + ' با تعداد ' + data.point + '/' + data.maxPoint} />
                    <meta property="twitter:card" content="ایاهو؛ موتور جستجوی اسب اصیل" />
                    <meta name="twitter:image:alt" content="ایاهو | موتور جستجوی اسب اصیل" />
                  </Helmet>
                  <Col xs={12}>
                    {data && <FeatureComponent feature={{...data, id: this.props.params.key}} user={user} isAuthenticated={auth.isAuthenticated} />}
                  </Col>
                </Row>)
              }
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

SingleFeatureScreen.fetchData = ({params}) => {
  return Actions.featureInfo(params.key)
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user.currentUser,
    feature: state.feature.currentFeature
  }
}

export default connect(mapStateToProps)(SingleFeatureScreen)



// WEBPACK FOOTER //
// ./src/components/Feature/SingleFeatureScreen.js